import { useTranslation } from 'react-i18next';
import JTLIcon from '@/icons/jtl.svg';
import { Link } from 'react-router';
import { AuthedRoutesEnum, JTLCredentialsStatusEnum } from '@/core/enums';
import { CreateJTLCredentialsDTO, JTLCredentials } from '@/core/types';
import InvalidIntegrationIcon from '@/icons/integration-invalid.svg?react';
import ConnectIcon from '@/icons/connect.svg?react';
import { Badge } from '../Badge/Badge';
import { JTLStatus } from './JTLStatus';

interface Props {
  jtlCredentials?: JTLCredentials | CreateJTLCredentialsDTO;
  prevRoute?: string;
}

export const JTLWidget = ({ jtlCredentials, prevRoute }: Props) => {
  const { t } = useTranslation();

  const isIntegrationPageMode =
    location.pathname === AuthedRoutesEnum.Integrations;

  const isConnectionActive =
    jtlCredentials?.status === JTLCredentialsStatusEnum.ConnectionEstablished ||
    jtlCredentials?.status === JTLCredentialsStatusEnum.ConnectionWithoutFiling;

  return (
    <>
      <div
        className='flex items-center justify-between font-bold'
        data-testid='integrations-jtl'
      >
        <div className='flex items-center'>
          <img
            src={JTLIcon}
            alt='jtl'
            style={{
              width: 40,
              height: 40,
            }}
            className='mr-2 flex-shrink-0'
          />
          <span>JTL</span>
        </div>
        {isIntegrationPageMode ? (
          <div className='flex items-center gap-x-2'>
            <Link
              to={AuthedRoutesEnum.JtlInstruction}
              state={{ prevRoute }}
              className='Button--outline flex max-w-[183px] items-center justify-center gap-x-1 !px-4 !py-1'
            >
              <span className='font-semibold'>{t('Setup information')}</span>
            </Link>
            {isConnectionActive && (
              <Badge
                color='green'
                className='flex items-center !px-2'
                label={
                  <>
                    <ConnectIcon className='Integrations__validIcon mr-1 inline-block !h-4 !w-4 items-center' />
                    <span>{t('Active')}</span>
                  </>
                }
              />
            )}
          </div>
        ) : null}
        {!isIntegrationPageMode ? (
          <Link
            to={AuthedRoutesEnum.JtlInstruction}
            state={{ prevRoute }}
            className='Button--outline flex !min-w-[118px] items-center justify-center gap-x-1 !px-2 !py-1 hover:text-white'
          >
            {jtlCredentials?.status ===
            JTLCredentialsStatusEnum.ConnectionLost ? (
              <InvalidIntegrationIcon className='h-4 w-4' />
            ) : (
              <ConnectIcon />
            )}
            <span>{t('Connect')}</span>
          </Link>
        ) : null}
      </div>
      <JTLStatus credentials={jtlCredentials} className='mt-2' />
    </>
  );
};
